import { createSlice } from "@reduxjs/toolkit";
import { fetchAllFeedback, submitFeedback } from "./operation.js";

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    loading: false,
    error: null,
    message: null,
    feedbacks: [],
  },
  reducers: {
    clearFeedbackMessage(state) {
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Submit feedback
      .addCase(submitFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(submitFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
      })
      .addCase(submitFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Ошибка при отправке отзыва";
      })

      // Fetch all feedbacks (admin, пока без авторизации)
      .addCase(fetchAllFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.feedbacks = action.payload;
      })
      .addCase(fetchAllFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Ошибка при загрузке отзывов";
      });
  },
});

export const { clearFeedbackMessage } = feedbackSlice.actions;
export default feedbackSlice.reducer;
